<template>
    <div>
        <!-- 头部 -->
        <div class="new_head">
            <div class="new_head_left">
                <!--<img src="../../assets/kyb_logo.png" alt="" class="new_logo">-->
              <a href="https://www.ruan.net" target="_blank"><img src="https://www.ruan.net/images/logo.png" alt="" class="new_logo"></a>
                <div class="new_list">
                    <div v-for="(item,index) in navlist" :key="index" @mouseover="toggle(index,item)"  :class="{activeclass:active==index}">
                        <router-link  active-class="nav-active" class="title_header"
                                   :to="item.routerlink">{{item.name}}
                      </router-link>
                    </div>
                </div>
                <div class="new_otherhead">
                  <!--<a href="https://chat.ruan.net" target="_blank"><img src="../../assets/qq_zxzx.png" alt="" class="qqimg"></a>-->
                     <span class="new_ye">
                         账户余额：
                        <router-link to="/recharge_center" class="pointer active">￥{{profile.balance}}</router-link>
                    </span>
                     <span class="new_userid">
                         用户ID：
                        <router-link to="/" class="active">{{profile.id}}</router-link>
                    </span>
                  <span class="new_userid" style="color: #0082e6;">您好：{{profile.name}}</span>
                  <a class="new_userid" @click="onLogout"  style="cursor: pointer;color: #0082e6;">退出</a>
                </div>
            </div>
            <!--<div class="new_head_right">-->
                <!--<div class="new_tx">
                    <img src="../../assets/tx.png" alt="">
                </div>-->
                <!--<div class="new_username">您好：{{profile.name}}</div>-->
              <!--<a @click="onLogout" style="margin-left: 10%;color: white" class="pointer">退出</a>-->
              <!--<div class="close close_white"></div>-->
            <!--</div>-->
        </div>

        <!-- 导航 -->
        <!-- <div class="header_nav w" :class="!isLogin?'unLogin':''">
            <div class="nav_logo" @click="$router.push('/')">
                <img :src="config.logo" :alt="config.site_title" class="pointer">
            </div>
            <div class="nav_right">
                <div class="per_center_right fr">
                    <div class="nav_group">





                      <span style="width: 150px"></span>

                      <router-link to="/#home" class="make_recharge nav_btn">
                        <i class="iconfont"></i>用户中心
                      </router-link>
                      <router-link to="/own" class="make_recharge nav_btn" style="margin:0 24px">
                        <i class="iconfont"></i>订单中心
                      </router-link>
                      <router-link to="/recharge_center" class="make_recharge nav_btn">
                        <i class="iconfont"></i>充值中心
                      </router-link>
                    </div>
                </div>
            </div>
        </div> -->

    </div>

</template>

<script>
    import * as Cookies from 'js-cookie'

    export default {
        data () {
            return {
                person: {},
                index: 0,
                show: true,
                 active: 0,
                navlist:[
                    {
                        routerlink:"/resource/news",
                        name:"媒体价格"
                    },
                    {
                        routerlink:"/resource/zimeiti?zimeiti=1",
                        name:"自媒体价格"
                    },
                    {
                        routerlink:"/own/publish",
                        name:"发布文章"
                    },
                    {
                        routerlink:"/own/copy_write",
                        name:"代写文章"
                    },
                    {
                        routerlink:"/recharge_center",
                        name:"在线充值"
                    },
                    {
                        routerlink:"/#home",
                        name:"后台首页"
                    }
                ]
            }
        },
        computed: {
            profile () {
                return this.$store.state.profile
            },
            isLogin () {
                return this.$store.state.auth.isLogin
            },
            taxonomies () {
                return this.$store.state.taxonomy
            },
            urlCallback () {
                return escape(document.URL)
            }
        },
        created () {
            if(this.$route.path.split('/')[1] == 'resource') {
                this.show = true
            } else if(this.$route.path.split('/')[1] == 'cart') {
                this.show = true
            } else {
                this.show = false
            }
        },
        methods: {
            onLogout () {
                let loadingInstance = this.$loading({
                    text: '注销中...'
                })

                this.$http
                    .post('/auth/logout', {device: 'pc'})
                    .then(response => {
                        if(response.success) {
                            //Cookies.remove("bearer");
                            window.location.href = 'https://www.ruan.net'
                        }
                    })
                    .catch()
                    .then(() => {
                        this.$nextTick(() => {
                            loadingInstance.close()
                        })
                    })
            },
            toggle(i, v) {
                this.active = i;
                }
        }
    }

</script>

<style scoped lang="scss">
    @import './../../../config.scss';

    /* 头部 */

    .head {
        background-color: $--head-background;
    }

    .head.unLogin {
        background-color: $--color-primary;
        position: fixed;
        width: 100%;
        z-index: 100;
        .head_top {
            color: #fff;
            text-align: center;
            justify-content: center;
            .btn {
                border: 1px solid #fff;
                padding: 3px 10px;
                color: #fff;
                border-radius: 2px;
                &:first-child {
                    margin-right: 12px;
                }
            }
        }
    }

    .head_top {
        font-size: 12px !important;
        height: 38px;
        color: $--head-color;
        display: flex;
        justify-content: space-between;
        min-width: 1200px;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        align-items: center;
    }

    .head_top_left {
        padding-left: 20px;
    }

    .head_top_right {
        color: black;
        padding-right: 60px;
    }

    .head_top_right > span {
        margin-right: 5px;
    }

    // .head_top_right a {
    //   color: $--head-color;
    // }
    .head_top_right > span:last-child {
        margin-right: 0;
    }

    .head_top ul {
        /* float: right; */
        margin-right: 48px;
    }

    .head_top ul li {
        float: left;
        /* margin-left: 10px; */
        font-size: 14px;
        line-height: 35px;
    }

    .head_top .tel {
        float: right;
        height: 35px;
        line-height: 40px;
    }

    /* 导航 */

    .header_nav {
        /* margin-top: 50px; */
        height: 100px;
        display: flex;
        align-items: center;
        /*justify-content: space-between;*/
    }

    .header_nav.unLogin {
        padding-top: 38px;
    }

    .header_nav .nav_logo {
        display: flex;
        align-items: center;
    }

    .header_nav .nav_logo img {
        padding-left: 20px;
        padding-right: 20px;
    }

    .header_nav .nav_right {
      margin-left: 17px;
        padding-right: 60px;
    }

    .nav_group {
        display: flex;
        justify-content: center;
    }

    .nav_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333333;
        font-size: 14px;
        width: 91px;
        height: 32px;
        margin: 0 4px;
        &:hover {
            background-color: $--color-primary;
            color: #fff
        }
        &:last-child {
            margin-right: 0
        }
        &:first-child {
            margin-left: 0
        }
    }

    /*
 */

    .per_center_right ul {
        width: 496px;
        /* margin-right: 36px; */
    }

    .nav_btn.nav-active {
        background: $--color-primary;
        color: #fff;
        border-radius: 2px;
        position: relative;
    }
    .nav_btn.nav-active::after{
        content: "";
        position: absolute;
        width: 100%;
        height: 5px;
        background-color: green;
    }
    .per_center_right li {
        font-size: 14px;
        color: #434343;
        float: left;
        /* width: 20%; */
        padding: 15px;
        padding-bottom: 0;

        text-align: center;
        line-height: 57px;
        padding-top: 21px;
    }

    .per_center_right li > a {
        color: #333333;
    }

    .make_recharge {
        visibility: hidden;
        color: $--color-primary;
        border-radius: 2px;
        font-weight: 700;
        width: 100px;
        height: 31px;
        border: 1px solid $--color-primary;
        &:hover {
            background-color: $--color-primary;
            color: #fff
        }
        i {
            margin-right: 4px
        }
    }

    .header-nav {
        display: flex;
        justify-content: space-between;
    }

    .header-nav > div {
        margin-left: 278px;
    }

    .header-nav > div > li {
        margin-right: 20px;
    }

    .steps {
        display: flex;
        height: 90px;
        justify-content: center;
        align-items: center;
    }

    .step-item {
        width: 200px;
    }

    .step-item:nth-child(4) {
        width: 17%;
    }

    .step-item > span {
        color: #999999;
        font-size: 16px;
    }

    .step-item > span:first-child {
        display: inline-block;
        width: 35px;
        height: 35px;
        background-color: #c9c9c9;
        border-radius: 50%;
        text-align: center;
        line-height: 35px;
        color: #ffffff;
    }

    .step-item > span:nth-child(3) {
        margin-left: 20px;
    }

    .steps > .active > span:nth-child(1) {
        background-color: $--color-primary;
    }

    .steps > .active > span:nth-child(2) {
        color: $--color-primary;
    }
    // 新头部样式
    .new_head{
        width: 100%;
        height: 80px;
        display: flex;
        justify-content: space-between;
    }
    .new_head_left{
        /*width: calc(100% - 220px);*/
        width: calc(100%);
        height: 100%;
        background: #FFFFFF;
        box-shadow: 3px 0px 9px 0px rgba(172, 200, 219, 0.46);
        display: flex;
        align-items: center;
        position: relative;
    }
  .new_head_right{
      width: 220px;
      height: 100%;
      background-image: url('../../assets/headimg.png');
      background-repeat: no-repeat;
      background-size: 100%;
      display: flex;
      align-items: center;
  }
.new_logo{
    width: 170px;
    height: 45px;
    margin-left: 54px;
}
.new_list{
    display: flex;
    justify-content: space-between;
    width: 450px;
    margin-left: 99px;
}
.new_otherhead{
    float: right;
    position: absolute;
    right: 30px;
    display: flex;
    align-items: center;
}
.qqimg{
    width: 120px;
    height: 36px;
}
.new_ye{
    margin-left: 45px;
    color: #999999;
}
.new_userid{
    margin-left: 33px;
    color: #999999;
}
.new_tx{
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-left: 45px;
}
.new_tx img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.new_username{
    margin-left: 11px;
    color: #fff;
}
.close{
    width: 17.1px;
    height: 17.2px;
    background-image: url(../../assets/close.png);
    background-size: 100%;
}
.close_white{
    background-position: 0 1px;
    margin-left: 40px;
}
.activeclass{
    position: relative;
}
.activeclass:after {
  content: '';
  position: absolute;
left: 0;
  bottom: -33px;
  width: 100%;
  opacity: 1;
  height: 4px;
  background-image: url(../../assets/top_xz.png);
  background-size: 100%;
}
.title_header{
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/global/Header.vue